export type ToolType = "pen" | "text" | "crop" | "shapes";

export type PenThickness = 3 | 6 | 10 | 16;

export const PEN_THICKNESS_PRESETS: PenThickness[] = [3, 6, 10, 16];

export interface Point {
    x: number;
    y: number;
}

export interface BaseDrawing {
    id: string;
    color: string;
}

export interface PenDrawing extends BaseDrawing {
    type: "pen";
    points: Point[];
    lineWidth: number;
}

export interface TextDrawing extends BaseDrawing {
    type: "text";
    position: Point;
    text: string;
    fontSize: number;
    /** Max width in canvas pixels — preserves line wrapping from editing */
    maxWidth: number;
}

export type ShapeType = "rectangle" | "circle" | "arrow";

export interface ShapeDrawing extends BaseDrawing {
    type: "shape";
    shapeType: ShapeType;
    start: Point;
    end: Point;
    lineWidth: number;
}

export type Drawing = PenDrawing | TextDrawing | ShapeDrawing;

/** Display font size (px) for new text annotations — used by both editor and overlay */
export const BASE_TEXT_FONT_SIZE = 24;
